import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import Link from '../../components/Link';
import {RightArrowIcon} from '../../components/svg';

const getCompanySlug = (guide) => guide?.company?.slug || _.kebabCase(guide.name);
const getCompanyName = (guide) => guide?.company?.name || '';

export const CompanyCard = (props) => {
  const companyName = getCompanyName(props);
  const companySlug = getCompanySlug(props);
  const subtitle = _.truncate(props.intro, {length: 130, separator: ' '});
  const guideUrl = props.slug ? `/guides/${props.slug}` : `/guides/${companySlug}/${props.role}`;

  return (
    <Link href={guideUrl} onClick={(e) => props.onClick(e, props)}>
      <div className="flex flex-col h-full text-left p-6 pb-5 shadow rounded border border-gray-200">
        <div>
          {props?.company?.logo && (
            <img
              className="h-12"
              src={`${props.company.logo}?w=200&h=200`}
              alt={props.name}
              onError={(e) => { e.target.style.display = 'none'; }}
            />
          )}
          <span className="block mt-4 text-xl font-semibold leading-6 text-black">
            {companyName}
          </span>
          <span className="block mb-2 text-base font-semibold leading-6 text-gray-600">
            {props.roleName}
          </span>
        </div>
        <div className="flex flex-col justify-between h-full">
          {subtitle && <span className="text-base leading-tight text-gray-800">{subtitle}</span>}
          <Link
            className="block text-right text-indigo text-sm font-semibold pt-2 pb-1 my-2 hover:text-indigo focus:text-indigo cursor-pointer"
            href={guideUrl}
          >
            View guide
            <RightArrowIcon className="w-4 ml-1.5" />
          </Link>
        </div>
      </div>
    </Link>
  );
};

export const Placeholder = () => (
  <div className="flex flex-col h-full text-left p-6 pb-5 shadow rounded border border-gray-200 animate-pulse">
    <div>
      <span className="block h-12 w-12 bg-gray-100 rounded" />
      <span className="block h-8 bg-gray-100 mt-4 mb-3 w-2/3 rounded" />
    </div>
    <div className="flex flex-col justify-between h-full">
      <span className="h-4 w-full bg-gray-100 rounded mb-2" />
      <span className="h-4 w-3/4 bg-gray-100 rounded mb-2" />
      <span className="h-4 w-3/4 bg-gray-100 rounded mb-4" />
    </div>
  </div>
);

const RequestGuideCard = () => {
  const href = 'https://airtable.com/appROifRg71Nsizjd/shrH6423pjEJEdqZg';

  return (
    <Link href={href} target="_blank" rel="noreferrer">
      <div className="flex flex-col h-full text-left p-6 pb-5 shadow rounded border border-dashed border-gray-500">
        <div>
          <span className="block mt-4 text-xl font-semibold leading-6 text-black">
            Don&apos;t see your guide?
          </span>
          <span className="block mb-2 text-base font-semibold leading-6 text-gray-600">
            Request access to new guides
          </span>
        </div>
        <div className="flex flex-col justify-between h-full">
          <span className="text-base leading-tight text-gray-800">
            Is there a guide missing from this list? Request a guide below to get early access
            to our beta guides as soon as we launch them.
          </span>
          <Link
            className="block text-right text-indigo text-sm font-semibold pt-2 pb-1 my-2 hover:text-indigo focus:text-indigo cursor-pointer"
            href={href}
          >
            Request beta guides
            <RightArrowIcon className="w-4 ml-1.5" />
          </Link>
        </div>
      </div>
    </Link>
  );
};

export const CompanyCards = (props) => (props.loading
  ? (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 max-w-6xl mx-auto gap-6">
      {_.times(6, () => <Placeholder />)}
    </div>
  ) : (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 max-w-6xl mx-auto gap-6">
      {props.items.map((item) => <CompanyCard {...item} key={item.name} onClick={props.onClick} />)}
      <RequestGuideCard />
    </div>

  ));

CompanyCard.propTypes = {
  name: PropTypes.string.isRequired,
  slug: PropTypes.string,
  role: PropTypes.string,
  company: PropTypes.shape({
    logo: PropTypes.shape().isRequired,
  }),
};

CompanyCard.defaultProps = {
  role: 'pm',
  company: null,
  slug: undefined,
};
